import styled from '@emotion/styled';
import { theme } from '@kindur/components';
import React from 'react';

export default (props: ContainerProps) => (
  <Container {...props}>{props.children}</Container>
);

/*
 *  STYLES
 */

const Container = styled('section')`
  width: 100%;
  background-color: ${(p: ContainerProps) => p.backgroundColor || 'inherit'};

  & > * {
    max-width: 1280px;
    margin: 0 auto;
    padding-top: ${(p: ContainerProps) => p.noPaddingTop ? 0 : theme.spacing.small * 4}px;
    padding-bottom: ${(p: ContainerProps) => p.noPaddingBottom ? 0 : theme.spacing.small * 4}px;
    padding-left: ${theme.spacing.small * 10}px;
    padding-right: ${theme.spacing.small * 10}px;

    ${theme.breakpoints.tabletDown} {
      padding-top: ${(p: ContainerProps) => p.noPaddingTop ? 0 : theme.spacing.small * 2}px;
      padding-bottom: ${(p: ContainerProps) => p.noPaddingBottom ? 0 : theme.spacing.small * 2}px;
      padding-left: ${theme.spacing.standard}px;
      padding-right: ${theme.spacing.standard}px;
    }
  }
`;

export interface ContainerProps {
  backgroundColor?: string;
  children?: any;
  noPaddingTop?: boolean;
  noPaddingBottom?: boolean;
}
